import styled from "styled-components";

export const StyledRowWrapper = styled.div`
    height: 100%;
      & > div {
        height: 100%;
        & > div {
            height: 100%;
        }
    }
`;